import React from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';
import {
  LoginScene,
  LogoutScene,
  MemberScene,
  MembersScene,
  NoTeamScene,
  ScheduleScene,
} from '../scenes';
import {useAuthToken, useTeams} from '../services';

export const Scenes: React.FC = () => {
  const location = useLocation();
  const authTokens = useAuthToken();
  const teams = useTeams();
  // As long as we're logged in we need to track
  // number of members in team and show the no team
  // scene when no teams are loaded
  return authTokens && teams.length === 0 ? (
    <NoTeamScene />
  ) : (
    <Switch location={location}>
      <Route path="/login">
        <LoginScene />
      </Route>
      <Route path="/logout">
        <LogoutScene />
      </Route>
      <Route path="/members/:id">
        <MembersScene />
      </Route>
      <Route path="/member/:teamId/:id">
        <MemberScene />
      </Route>
      <Route path="/schedule/:id/:type/:date">
        <ScheduleScene />
      </Route>
      <Route path="/noteam">
        <NoTeamScene />
      </Route>
    </Switch>
  );
};
